var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,_vm._g(_vm._b({tag:"component",staticClass:"tr-input no-outline",class:( _obj = {
		'tr-input--has-error': _vm.hasError
	}, _obj[_vm.FOCUSABLE_ERROR_INPUT_CLASS] = _vm.hasError, _obj ),attrs:{"value":_vm.value}},'component',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }